export { default } from "./deviceFingerprint";
